import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  linkVndlyPosition,
  type LinkVndlyPositionParams,
} from 'api/admin/vndly/linkVndlyPosition'
import { vndlyKeys } from './keys'

export const useLinkVndlyPositionMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: LinkVndlyPositionParams) => linkVndlyPosition(params),
    onSuccess: async () =>
      queryClient.invalidateQueries({ queryKey: vndlyKeys.positionIssues() }),
  })
}
